import { Select, SelectProps, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { makeRequest } from '@helpers/axios-manipulator';
import { User } from '@models/user';
import userImg from "../../../../assets/images/user-unknow.png";

type Props = {
    debugInfo?: any;
  setData: Function,
  data: any,
  className?: string,
  update?: boolean,
  width?: string,
  route?: string,
  disableField?: boolean,
  selectedUser?: string,
  saveUsername?: Function,
  status?: '' | 'error' | 'warning' | 'success';
  usedDealerIds?: string[];
  extraUserIds?: string[];
  allowedTypes?: number[];
}

const UserSelect = ({ setData, data, className, update, width, route, disableField, selectedUser, saveUsername, status, usedDealerIds, extraUserIds, allowedTypes, debugInfo }: Props) => {
  const [options, setOptions] = useState<SelectProps['options']>()
  const [allUsers, setAllUsers] = useState<User[]>([])
  const [selected, setSelected] = useState<string | null>(selectedUser || null);

  useEffect(() => {
    const getUsers = async () => {
      try {
        const response = await makeRequest({
          origin: window.location.origin,
          method: 'get',
          url: `${route || '/api-users'}`,
          headers: {},
        });

        if (!Array.isArray(response)) {
          console.error('Invalid user response:', response);
          return;
        }

        let mergedUsers = response;
        // If extraUserIds is provided, merge in those users (if not already present)
        if (Array.isArray(extraUserIds) && extraUserIds.length > 0) {
          const missingIds = extraUserIds.filter(id => !response.some((u: any) => u.id === id));
          if (missingIds.length > 0) {
            // Fetch missing users by id (assuming /api-users-search or similar endpoint exists)
            const extraResponses = await Promise.all(missingIds.map(id => makeRequest({
              origin: window.location.origin,
              method: 'get',
              url: `/api-user/${id}`,
              headers: {},
            })));
            mergedUsers = [...response, ...extraResponses.filter(Boolean)];
          }
        }

        // Filter by allowedTypes if provided
        let filteredUsers = mergedUsers;
        if (Array.isArray(allowedTypes) && allowedTypes.length > 0) {
          filteredUsers = mergedUsers.filter((u: any) => allowedTypes.includes(Number(u.type)));
        }

        setAllUsers(filteredUsers);

        const opts: SelectProps['options'] = filteredUsers.map((r: any) => ({
          label: r.username,
          value: r.id,
          emoji: r.profile_image_url || userImg,
          desc: r.username,
          disabled: usedDealerIds?.includes(r.id),
          type: r.type, // Add type for filtering/debugging
          user: r,      // Add full user object for debugging
        }));

        setOptions(opts);

        if (selected) {
          const value = mergedUsers.find((objeto: User) => objeto.id === selected);
          if (value) {
            if (saveUsername) saveUsername(value.username);
            setData(value);
          }
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    getUsers();
  }, [update, allowedTypes]);
  const handleChange = (value: any) => {
    const user = allUsers.find(u => u.id === value) as User;
    if (user) {
      setSelected(user.id);
      setData(user);
      if (saveUsername) saveUsername(user.username);
    }
  };

  useEffect(() => { if (selectedUser) setSelected(selectedUser) }, [selectedUser])
  // Debug: log dropdown options for rep context
  useEffect(() => {
  }, [options, debugInfo]);

  return (
    <Select
      className={className}
      showSearch
      loading={options?.length === 0}
      style={{ width: width ? width : '100%' }}
      placeholder="Select One Account"
      optionFilterProp='label'
      onChange={handleChange}
      optionLabelProp="label"
      options={options}
      disabled={disableField}
      value={selected}
      maxLength={30}
      status={status}
      optionRender={(option) => {
        const isDisabled = option.data.disabled;
        return (
          <Space>
            <span>{option.data.username}</span>
            <img
              style={{ objectFit: 'cover' }}
              width={50}
              height={50}
              src={option.data.emoji}
              alt={option.data.username}
              onError={e => {
                const target = e.currentTarget;
                if (target.src !== userImg) target.src = userImg;
              }}
            />
            {option.data.desc}
            {option.data.disabled && (
              <span style={{ color: '#ff4d4f', marginLeft: 8, fontWeight: 500 }}>
                (Already in Use)
              </span>
            )}
          </Space>
        );
      }}
    />
  )
}

export default UserSelect